import { FETCH_TOPICS } from './constants'

const initialState = {
  isFetching: false,
  items: []
}

export default function topicsReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_TOPICS.REQUEST: {
      return {
        ...state,
        isFetching: true
      }
    }
    case FETCH_TOPICS.SUCCESS: {
      return {
        ...state,
        isFetching: false,
        items: action.topics,
        deviceId: action.deviceId
      }
    }
    default: {
      return state
    }
  }
}
